export default {"src":"/_next/static/media/invite-icon.e55f04d6.svg","height":21,"width":21};